/**
 * @description baseOptions 中的方法只能扩展到 Vue 的prototype 中，而不能扩展到vue.$options 中
 * @date
 * @author lei.you
 * */
import Vue from 'vue';
var baseOptions ={
  //hubus:new Vue(),
    _self:this,
    /**
     * @desc : native 注册以后可通过onResume去触发, 每次当activity 切换的时候调用该方法，待覆盖
     * @param : data 数据，页面切换间传递
     *
     * */
    appear(data){

    },
    /**
     * @description native 通知h5 网络状态 待覆盖
     * @param data  状态分为 蜂窝移动 wifi 和无网络
     * */
    networkChange(data){

    },
    /**
     * @description 用户点击浏览器回退触发的注册事件 待覆盖
     * @param
     * */
    webBrowserBackCallback(){

    }
  //query:this.route.query
};

export default baseOptions
